import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaReact, FaNodeJs, FaJava, FaPython, FaDatabase } from "react-icons/fa";
import Pratik from "../assets/Pratik.jpg";
import "./About.css";

const skills = [
  { name: "MRRN Stack", icon: <FaReact /> },
  { name: "Java Full Stack", icon: <FaJava /> },
  { name: "Python Development", icon: <FaPython /> },
  { name: "MongoDB", icon: <FaDatabase /> },
  { name: "Express.js", icon: <FaNodeJs /> },
  { name: "React.js", icon: <FaReact /> },
  { name: "Node.js", icon: <FaNodeJs /> },
  { name: "SQL", icon: <FaDatabase /> },
  { name: "DSA", icon: "🔢" },
  { name: "Figma", icon: "🎨" },
];

const About = () => {
  return (
    <motion.section
      id="about"
      className="about-section bg-light text-dark py-5"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <Container>
        <Row className="align-items-center">
          <Col md={6}>
            <h2 className="about-heading">About Me</h2>
       <p className="about-description">
  I'm a Full Stack Developer and freelancer with a solid foundation in HTML, CSS, JavaScript, and modern styling frameworks like Bootstrap and Tailwind CSS. I build responsive, high-performance web applications using ReactJS, Next.js, Node.js, Express.js, MongoDB, and SQL. I'm also skilled in REST APIs, Python, Java, and UI/UX tools like Figma.
  I frequently use Postman for API testing and Git/GitHub for version control and collaboration. I enjoy solving real-world problems and delivering clean, user-friendly digital solutions.
</p>
<p className="about-highlights">
  Passionate about continuous learning and exploring technologies like TypeScript, GraphQL, Firebase, and AWS. Always open to exciting freelance opportunities and new technical challenges.
</p>


            {/* Skills Section */}
            <div className="skills-section mt-4">
              <h5 className="skills-heading">Tech Stack & Skills:</h5>
              <div className="skills-grid">
                {skills.map((skill, index) => (
                  <motion.div
                    className="skill-tag"
                    key={index}
                    whileHover={{ scale: 1.05 }}
                    transition={{ type: "spring", stiffness: 300 }}
                  >
                    <span className="skill-icon">{skill.icon}</span> {skill.name}
                  </motion.div>
                ))}
              </div>
            </div>
          </Col>

          <Col md={6}>
            <img
              src={Pratik}
              alt="Pratik"
              className="img-fluid about-image"
            />
          </Col>
        </Row>
      </Container>
    </motion.section>
  );
};

export default About;
